
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 62 62"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(2 2)","fill":"none","fill-rule":"evenodd","opacity":".75"}},[_c('circle',{attrs:{"stroke":"var(--vote-color, #fff)","stroke-width":"3","cx":"29","cy":"29","r":"29"}}),_c('circle',{attrs:{"fill":"var(--vote-color, #fff)","cx":"18.125","cy":"22.958","r":"3.625"}}),_c('circle',{attrs:{"fill":"var(--vote-color, #fff)","cx":"39.875","cy":"22.958","r":"3.625"}}),_c('path',{attrs:{"d":"M18.125 40.194h21.75a1.813 1.813 0 000-3.625h-21.75a1.813 1.813 0 000 3.625z","fill":"var(--vote-color, #fff)","fill-rule":"nonzero"}})])])
          )
        }
      }
    